export default __webpack_public_path__ + "static/media/todd-krupa-bio-pic.7069e62b.jpg";